import { FadeUp, Overline } from "../components/Motion";

const CHAPTERS = [
  {
    num: "01",
    title: "Light is the subject",
    body: "Every frame starts with how light falls. Whether it's a boardroom window or a stage strobe, we shape it to reveal character, not hide it.",
  },
  {
    num: "02",
    title: "People, not poses",
    body: "The best portraits happen between the poses. We direct with intent but shoot for the honest, in-between moments that actually feel like you.",
  },
  {
    num: "03",
    title: "Built for the brand",
    body: "From a single executive headshot to a full campaign, everything is delivered to work across web, social, and print — cohesive, consistent, on-message.",
  },
];

const Manifesto = () => (
  <section id="studio" data-testid="manifesto-section" className="bg-[#050505] py-28 md:py-40">
    <div className="mx-auto max-w-[1600px] px-6 md:px-12">
      <FadeUp>
        <Overline>The Approach</Overline>
        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-6 max-w-2xl leading-[1.05]">
          A studio obsessed with <span className="italic">the details</span> most miss.
        </h2>
      </FadeUp>

      <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-x-12 gap-y-16">
        {CHAPTERS.map((c, i) => (
          <FadeUp key={c.num} delay={i * 0.12}>
            <div className="relative border-t border-white/15 pt-8">
              <span className="font-serif text-7xl md:text-8xl text-white/10 absolute -top-10 -left-2 select-none">
                {c.num}
              </span>
              <h3 className="relative font-serif text-2xl md:text-3xl mb-4">{c.title}</h3>
              <p className="relative text-[#A1A1AA] leading-relaxed">{c.body}</p>
            </div>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);

export default Manifesto;
